export { CharacterModelTrait, ICharacterModelData, CharacterPredicate } from './characterModelTrait';
export * from './character-vocabulary';
